import { useNavigate } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

const ButtonBack = withStyles((theme) => ({
  root: {
    border: 'none',
    background: 'transparent',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.background.card,
      borderColor: theme.palette.common.white,
      boxShadow: 'none',
    },
  },
}))(Button);

export default function ReturnButton() {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <ButtonBack
        disableElevation
        variant="contained"
        onClick={() => navigate(-1)}
        startIcon={<NavigateBeforeIcon />}
      >
        Volver
      </ButtonBack>
    </div>
  );
}
